<template>
  <thead class="bg-gray-50">
    <tr>
      <th
        scope="col"
        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider w-full"
      >
        {{ $t('global.name') }}
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
      >
        {{ $t('global.email') }}
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
      >
        {{ $t('global.phone') }}
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
      >
        {{ $t('global.assigned_to') }}
      </th>
      <th
        v-if="$membershipHasPermissionTo('read contact requests')"
        scope="col"
        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
      >
        {{ $t('global.requests') }}
      </th>
      <th
        v-if="$membershipHasPermissionTo('read acc orders')"
        scope="col"
        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
      >
        {{ $t('global.orders') }}
      </th>
      <th
        scope="col"
        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
      >
        {{ $t('global.created') }}
      </th>
    </tr>
  </thead>
</template>

<script>
export default {};
</script>
